import $ from 'jquery';

import * as requestLib from './requestLib';

let baseUrl = requestLib.getUrl();

export default {
	requestPost: (url, data, callback, errorCallback = () => { }) => {
		url = baseUrl + url;
		$.ajax({
			url,
			data,
			dataType: 'json',
			type: 'post',
			beforeSend: function (xhr) { },
			success: function (res) {
				callback(res);
			},
			error: (req, status, err) => {
				errorCallback(req, status, err);
			},
		});
	},

	requestGet: (url, data, callback, errorCallback = () => { }) => {
		url = baseUrl + url;
		$.ajax({
			url,
			data,
			beforeSend: function (xhr) { },
			dataType: 'json',
			type: 'get',
			success: (res) => {
				callback(res);
			},
			error: (req, status, err) => {
				errorCallback(req, status, err);
			},
		});
	},

	getCookie: (name) => {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
	},

	getDate: (timestamp) => {
		var d = new Date(timestamp * 1000),
			yyyy = d.getFullYear(),
			mm = ('0' + (d.getMonth() + 1)).slice(-2), // Months are zero based. Add leading 0.
			dd = ('0' + d.getDate()).slice(-2), // Add leading 0.
			time = yyyy + '.' + mm + '.' + dd;

		return time;
	},
};



// WEBPACK FOOTER //
// ./src/lib/commonMethod.js